module.exports = __webpack_public_path__ + "img/WarumDieSocke.cb9d5d77.jpg";